import Button from "@commons/Button";
import Heading from "@commons/Typography/Heading";
import Text from "@commons/Typography/Text";
import { type ReactNode } from "react";

type PageCardProps = {
  title: string;
  icon: ReactNode;
  buttonText: string;
  visible?: boolean;
  onButtonClick?: () => void;
};

function PageCard({
  title,
  icon,
  buttonText,
  visible = true,
  onButtonClick,
}: PageCardProps) {
  if (!visible) return null;
  return (
    <div
      className="bg-white w-full p-6 rounded-3xl shadow-sm flex items-center justify-between gap-3
                transition-transform duration-300
                hover:scale-102 hover:shadow-lg
                flex-1 min-w-68 xs:min-w-80"
    >
      <div className="flex flex-col gap-4 xl:gap-6">
        <Heading size="md">{title}</Heading>
        <Button onClick={onButtonClick} customVariant="secondary" size="auto">
          <Text size="sm">{buttonText}</Text>
        </Button>
      </div>
      <div className="text-primary">{icon}</div>
    </div>
  );
}

export default PageCard;
